import api from "../util/api";
import * as actions from "../store/modules/conferenciaCp/actions";
import { maskMoeda } from "../util/masks";
import { setLoading } from "../store/modules/globalLoading/actions";
import {
  notifySuccess,
  notifyWarn,
} from "../components/message/message";
import { guidGenerator } from "../util/guidGenerator";

export async function getContasPagarAgrupada(pesquisa, pageSize, page) {
  var url = `conta-pagar-agrupado/paginado?Pagina=${page}&Quantidade=${pageSize}`;
  if (pesquisa.campanhaPremiacaoId !== "0") {
    url = url + `&CampanhaPremiacaoId=${pesquisa.campanhaPremiacaoId}`;
  }
  if (pesquisa.empresaId !== "0") {
    url = url + `&EmpresaId=${pesquisa.empresaId}`;
  }
  if (pesquisa.tipoRegraId !== "0") {
    url = url + `&TipoRegraId=${pesquisa.tipoRegraId}`;
  }
  if (pesquisa.dataAceito !== "") {
    url = url + `&DataAceito=${pesquisa.dataAceito}`;
  }
  if (pesquisa.sistemaId !== "0") {
    url = url + `&SistemaId=${pesquisa.sistemaId}`;
  }
  if (pesquisa.statusId !== "0") {
    url = url + `&StatusId=${pesquisa.statusId}`;
  }

  setLoading(true);
  const data = await api.get(url);
  setLoading(false);
  if (!data.success) {
    return;
  }

  data.content.registros.forEach((item) => {
    item.dataAceito = new Date(Date.parse(item.dataAceito));
  });

  actions.setContasPagarAgrupado(data.content.registros);
  actions.setPagination({
    quantidade: data.content.quantidade,
    quantidadeTotal: data.content.quantidadeTotal,
    totalPaginas: data.content.totalPaginas,
    tamanhoPagina: data.content.tamanhoPagina,
  });
}

export async function getCampanhaPremiacao() {
  const data = await api.get("CampanhaPremiacao/campanhas-processadas");

  if (!data.success) {
    return;
  }

  actions.setOptionsSelect("campanhas", data.content);
}

export async function getEmpresas() {
  const data = await api.get("EmpresaFuncionario");

  if (!data.success) {
    return;
  }

  actions.setOptionsSelect("empresas", data.content);
}

export async function getTiposPagamento() {
  const data = await api.get("CampanhaPremiacao/tipos-regras");

  if (!data.success) {
    return;
  }

  actions.setOptionsSelect("tiposPagamento", data.content);
}

export async function getSistemas() {
  const data = await api.get("contas-pagar/sistemas");

  if (!data.success) {
    return;
  }

  actions.setOptionsSelect("sistemas", data.content);
}

export async function getStatus() {
  const data = await api.get("contas-pagar/status");

  if (!data.success) {
    return;
  }

  actions.setOptionsSelect("status", data.content);
}

export async function getFiltros() {
  setLoading(true);
  await Promise.all([
    getCampanhaPremiacao(),
    getEmpresas(),
    getTiposPagamento(),
    getSistemas(),
    getStatus(),
  ]);
  setLoading(false);
}

async function processarLote(contas, url, acao) {
  if (contas.length === 0) {
    notifyWarn(`Selecione ao menos uma conta para ${acao.infinitivo}`);
    return { falhas: [], sucessos: 0 };
  }

  setLoading(true);
  const results = await Promise.all(
    contas.map((conta) =>
      api.put(`${url}/${conta.id}`, undefined, { silent: true })
    )
  );
  setLoading(false);

  const falhas = [];
  results.forEach((result, index) => {
    if (!result.success) {
      falhas.push({
        conta: contas[index],
        mensagem: result.messages?.[0] || "Não foi possível realizar a ação.",
      });
    }
  });

  const sucessos = contas.length - falhas.length;

  if (falhas.length === 0) {
    notifySuccess(
      `${sucessos} ${sucessos === 1 ? acao.singular : acao.plural} com sucesso`
    );
  }

  return { falhas, sucessos };
}

async function getContasDoGrupo(conta) {
  const url =
    `conta-pagar-agrupado/paginado?Pagina=1&Quantidade=100` +
    `&CampanhaPremiacaoId=${conta.campanhaId}` +
    `&EmpresaId=${conta.empresaId}` +
    `&TipoRegraId=${conta.tipoRegraId}`;
  const data = await api.get(url);
  return data.success ? data.content.registros : [];
}

function chaveDoGrupo(conta) {
  return `${conta.campanhaId}|${conta.empresaId}|${conta.tipoRegraId}`;
}

export async function getStatusAtualFalhas(falhas) {
  const consultas = new Map();
  falhas.forEach(({ conta }) => {
    const chave = chaveDoGrupo(conta);
    if (!consultas.has(chave)) {
      consultas.set(chave, getContasDoGrupo(conta));
    }
  });

  setLoading(true);
  const falhasComStatus = await Promise.all(
    falhas.map(async (falha) => {
      const registros = await consultas.get(chaveDoGrupo(falha.conta));
      const atual = registros.find((r) => r.id === falha.conta.id);
      return { ...falha, statusAtual: atual ? atual.status : null };
    })
  );
  setLoading(false);

  return falhasComStatus;
}

export async function aprovarContas(contas) {
  return processarLote(
    contas,
    "conta-pagar-agrupado/aprova-contas-pagar-agrupado",
    {
      infinitivo: "aprovar",
      singular: "conta aprovada",
      plural: "contas aprovadas",
    }
  );
}

export async function estornarContas(contas) {
  return processarLote(
    contas,
    "conta-pagar-agrupado/estorna-contas-pagar-agrupado",
    {
      infinitivo: "estornar",
      singular: "conta estornada",
      plural: "contas estornadas",
    }
  );
}

export async function aprovarConta(id) {
  setLoading(true);
  const data = await api.put(
    `conta-pagar-agrupado/aprova-contas-pagar-agrupado/${id}`
  );
  setLoading(false);

  if (!data.success) {
    return false;
  }

  notifySuccess("Conta aprovada com sucesso");
  return true;
}

export async function estornarConta(id) {
  setLoading(true);
  const data = await api.put(
    `conta-pagar-agrupado/estorna-contas-pagar-agrupado/${id}`
  );
  setLoading(false);

  if (!data.success) {
    return false;
  }

  notifySuccess("Conta estornada com sucesso");
  return true;
}

export async function getContaPagarAgrupadoItens(id) {
  actions.setContaPagarAgrupadoItens([]);
  setLoading(true);
  const data = await api.get(`conta-pagar-agrupado/${id}/itens`);
  setLoading(false);

  if (!data.success) {
    return false;
  }

  data.content.forEach((item) => {
    item.valor = maskMoeda(item.valor?.toFixed(2));
  });

  actions.setContaPagarAgrupadoItens(data.content);
  return true;
}

export async function alteraSistemaContaPagar(id, sistemaId) {
  setLoading(true);
  const data = await api.put(
    `conta-pagar-agrupado/altera-sistema-conta-pagar/${id}/sistema/${sistemaId}`
  );
  setLoading(false);

  if (!data.success) {
    return false;
  }

  notifySuccess("Conta atualizada com sucesso");
  return true;
}

export async function downloadPlanilha(id) {
  setLoading(true);
  const data = await api.get(`conta-pagar-agrupado/${id}/planilha`);
  setLoading(false);

  if (!data.success) {
    return false;
  }

  actions.setDownload({
    arquivoBase64: data.content,
    nomeArquivo: `${guidGenerator()}.csv`,
  });

  return true;
}
